/**
 * @hidden
 */
export var ActiveDescendant;
(function (ActiveDescendant) {
    ActiveDescendant[ActiveDescendant["PopupList"] = 0] = "PopupList";
    ActiveDescendant[ActiveDescendant["TagsList"] = 1] = "TagsList";
})(ActiveDescendant || (ActiveDescendant = {}));
//# sourceMappingURL=settings.js.map